/**
 * Shared primary chip for post kinds. Wrappers can override style when a domain
 * needs context-specific coloring, such as impact polarity.
 */
import React from "react";
import { Chip } from "ui/Chip";
import { getPostDisplayDefinition } from "components/Posts/display/postDisplayConfig";
import type { PostDisplayKind } from "components/Posts/display/postDisplayTypes";

interface PostKindChipProps {
  kind: PostDisplayKind;
  className?: string;
  style?: React.CSSProperties;
}

const PostKindChip: React.FC<PostKindChipProps> = ({ kind, className, style }) => {
  const definition = getPostDisplayDefinition(kind);
  const Icon = definition.Icon;

  return (
    <Chip
      variant="custom"
      size="sm"
      icon={<Icon className={definition.iconClassName} />}
      className={className ?? definition.chipClassName}
      style={style}
    >
      {definition.label}
    </Chip>
  );
};

export default PostKindChip;
